import { render, staticRenderFns } from "./BeneficiaryReadOnlyRegistration.vue?vue&type=template&id=8a531b56"
import script from "./BeneficiaryReadOnlyRegistration.vue?vue&type=script&lang=js"
export * from "./BeneficiaryReadOnlyRegistration.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryReadOnlyRegistration.vue?vue&type=style&index=0&id=8a531b56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCheckbox,
  VContainer,
  VDivider,
  VFlex,
  VLayout,
  VProgressCircular,
  VSwitch,
  VTextField,
})
